import { useState, Component, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Card, Tooltip, Typography, Skeleton, Input, Tabs, InputNumber, Button } from "antd";
import { Animate, AnimateGroup } from "react-simple-animate";
import dayjs from "dayjs";
import Axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import moment from "moment";
import { PatternFormat, NumericFormat } from "react-number-format";
import ReactToPrint from "react-to-print";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

function PortalPayment(props) {
  const params = useParams();
  const focusOnEdit = useRef(null);
  const printableRef = useRef(null);

  const [invoice, setInvoice] = useState(null);
  const [client, setClient] = useState(null);
  const [company, setCompany] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState({ editing: false, total: 0 });
  const [apiLoginId, setApiLoginId] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [animation1Playing, setAnimation1Playing] = useState(false);
  const [animation2Playing, setAnimation2Playing] = useState(false);

  const GetInvoice = async () => {
    let response = await props.AxiosRequest("/api/portal/invoice/get", { invoice_tag: params.invoice_tag, client_tag: params.client_tag });
    setInvoice(response.data.invoice);
    setClient(response.data.client);
    setCompany(response.data.company);
    setApiLoginId(response.data.company.merchant_api_login_credentials);
    setPaymentDetails({ ...paymentDetails, total: response.data.invoice.total });
  };

  const GetClient = async () => {
    let response = await props.AxiosRequest("/api/portal/client/get", { company_tag: params.company_tag, client_tag: params.client_tag });
    setClient(response.data.client);
    setCompany(response.data.company);
    setApiLoginId(response.data.company.merchant_api_login_credentials);
    setPaymentDetails({ ...paymentDetails, total: 0 });
  };

  const GetCompany = async () => {
    let response = await props.AxiosRequest("/api/portal/firm/get", { company_tag: params.company_tag });
    setCompany(response.data.company);
    setApiLoginId(response.data.company.merchant_api_login_credentials);
    setPaymentDetails({ ...paymentDetails, total: 0 });
  };

  const ReadSwipeInput = async () => {
    if (
      paymentDetails?.first_name &&
      paymentDetails?.first_name[0] === "%" &&
      paymentDetails?.first_name.indexOf("=") > 0 &&
      paymentDetails?.first_name[paymentDetails?.first_name.length - 1] === "?"
    ) {
      let card_number = paymentDetails.first_name.substring(2, 18);
      let last_name = paymentDetails.first_name.substring(paymentDetails.first_name.indexOf("^") + 1, paymentDetails.first_name.indexOf("^", paymentDetails.first_name.indexOf("^") + 1));
      let first_name = "";
      if (last_name.indexOf("/")) {
        first_name = last_name.substring(last_name.indexOf("/") + 1);
        last_name = last_name.substring(0, last_name.indexOf("/"));
      }
      let expiration_month = paymentDetails.first_name.substring(
        paymentDetails.first_name.indexOf("^", paymentDetails.first_name.indexOf("^") + 1) + 3,
        paymentDetails.first_name.indexOf("^", paymentDetails.first_name.indexOf("^") + 1) + 5,
      );

      let expiration_year = paymentDetails.first_name.substring(
        paymentDetails.first_name.indexOf("^", paymentDetails.first_name.indexOf("^") + 1) + 1,
        paymentDetails.first_name.indexOf("^", paymentDetails.first_name.indexOf("^") + 1) + 3,
      );
      setPaymentDetails({ ...paymentDetails, first_name: first_name, last_name: last_name, card_number: card_number, card_expiry_month: expiration_month, card_expiry_year: "20" + expiration_year });
    }
  };

  const ChargeCard = async (resp) => {
    let response = await props.AxiosRequest("/api/forte/transaction/ott", {
      client_tag: client?.tag,
      company_tag: company?.tag,
      ott: resp.onetime_token,
      first_name: paymentDetails?.first_name,
      last_name: paymentDetails?.last_name,
      memo: paymentDetails?.memo,
      amount: paymentDetails?.total,
    });
    if (response.data.status === "Error") {
      props.MakeNotification("error", response.data.message || "There was a backend error. Please try again.");
      setPaymentProcessing(false);
    }
    if (response.data.status === "success") {
      props.MakeNotification("success", response.data.message || "Payment initiated successfully.");
      AnimatePaymentSuccess();
    }
  };
  const HandleForteSuccess = (e) => {
    ChargeCard(e);
  };
  const HandleForteFailure = (e) => {
    setPaymentProcessing(false);
    console.log(e);
    let responses = {
      "The browser you are using is not supported. Fortejs supports the latest versions of the following browsers: Internet Explorer, Firefox, Chrome, and Safari.":
        "The browser you are using is not supported. Fortejs supports the latest versions of the following browsers: Internet Explorer, Firefox, Chrome, and Safari.",
      "The browser you are using is not supported. Please download the latest version of your browser to use Fortejs.":
        "The browser you are using is not supported. Please download the latest version of your browser to use Fortejs.",
      "The api_login_id is required.": "Unexpected Error.",
      "The expire_month is required.": "Expiration month is required.",
      "The account_number is required.": "Account number is required.",
      "The routing_number is required.": "Routing number is required.",
      "The routing_number is invalid.": "Routing number is invalid.",
      "The account_type is required.": "Account type is required.",
      "The account_type is invalid.": "Account type is invalid.",
      "The expire_year is required.": "Expiration year is required.",
      "The cvv is required.": "CVV is required.",
      "The card_number is invalid.": "The card number is invalid.",
      "The cvv is invalid.": "The CVV is invalid.",
      "The expire_month and expire_year are invalid.": "The expiration provided is invalid.",
      "Invalid authentication.": "Unexpected error.",
    };
    if (responses[e.response_description]) return props.MakeNotification("error", responses[e.response_description]);

    props.MakeNotification("error", "An error occurred.");
  };

  const SubmitCardTransaction = () => {
    if (paymentDetails?.first_name?.length === 0) return props.MakeNotification("warning", "Please enter a first name.");
    if (paymentDetails?.last_name?.length === 0) return props.MakeNotification("warning", "Please enter a last name.");
    if (paymentDetails?.total <= 0) return props.MakeNotification("warning", "Please enter an amount for this payment.");
    if (!paymentDetails?.card_number || !paymentDetails?.card_expiry_year || !paymentDetails?.card_expiry_month || !paymentDetails?.card_ccv || !paymentDetails?.card_zip)
      return props.MakeNotification("warning", "Please enter all required fields for this payment.");

    setPaymentProcessing(true);
    var data = {
      api_login_id: apiLoginId,
      card_number: paymentDetails.card_number,
      expire_year: paymentDetails.card_expiry_year,
      expire_month: paymentDetails.card_expiry_month,
      cvv: paymentDetails.card_ccv,
      zip: paymentDetails.card_zip,
    };
    window.forte.createToken(data).success(HandleForteSuccess).error(HandleForteFailure);
  };
  const AnimatePaymentSuccess = () => {
    setAnimation1Playing(true);
    return;
  };

  const payment_tabs = [
    {
      key: "1",
      label: "Debit Card",
      children: (
        <>
          <Typography.Title level={4} className="card-title">
            Debit Card Payment Information
          </Typography.Title>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <label className="col-form-label-sm" htmlFor="first_name_on_card">
                First Name *
              </label>
              <Input
                size="large"
                type="text"
                id="first_name_on_card"
                name="first_name_on_card"
                value={paymentDetails?.first_name}
                onChange={(e) => setPaymentDetails({ ...paymentDetails, first_name: e.target.value })}
                placeholder="John"
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm" htmlFor="last_name_on_card">
                Last Name *
              </label>
              <Input
                size="large"
                type="text"
                id="last_name_on_card"
                name="last_name_on_card"
                value={paymentDetails?.last_name}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, last_name: e.target.value });
                }}
                placeholder="Smith"
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm" htmlFor="card_number">
                Card Number *
              </label>
              <PatternFormat
                id="card_number"
                className="form-control form-control-lg"
                format="#### #### #### ####"
                mask="-"
                placeholder="---- ---- ---- ----"
                value={paymentDetails.viewable_card_number}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, card_number: e.target.value.replaceAll(" ", "").replaceAll("-", ""), viewable_card_number: e.target.value });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm" htmlFor="card_expiry">
                Card Expiration *
              </label>
              <PatternFormat
                id="card_expiry"
                className="form-control form-control-lg"
                format="##/##"
                mask="-"
                placeholder="MM/YY"
                value={paymentDetails?.card_expiry_month && paymentDetails?.card_expiry_year ? paymentDetails?.card_expiry_month + paymentDetails?.card_expiry_year.substring(2) : null}
                onChange={(e) => {
                  setPaymentDetails({
                    ...paymentDetails,
                    card_expiry_month: e.target.value.substr(0, Number(e.target.value.indexOf("/"))),
                    card_expiry_year: "20" + e.target.value.substr(e.target.value.indexOf("/") + 1),
                  });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm" htmlFor="card_ccv">
                CCV *
              </label>
              <NumericFormat
                id="card_ccv"
                className="form-control form-control-lg"
                format="###"
                mask="-"
                placeholder="---"
                allowLeadingZeros={true}
                value={paymentDetails?.ccv}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, card_ccv: e.target.value });
                }}
              />
            </Col>
            <Col span={10}>
              <label className="col-form-label-sm" htmlFor="card_zip">
                Zip *
              </label>
              <NumericFormat
                id="card_zip"
                className="form-control form-control-lg"
                format="#####"
                mask="-"
                placeholder="-----"
                allowLeadingZeros={true}
                value={paymentDetails?.card_zip}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, card_zip: e.target.value });
                }}
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm" htmlFor="card_zip">
                Memo
              </label>
              <Input.TextArea
                maxLength={1000}
                showCount
                value={paymentDetails?.memo}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, memo: e.target.value });
                }}
              />
            </Col>
            <Col span={24} className="text-right mt-2">
              <Button type="primary" loading={paymentProcessing} onClick={SubmitCardTransaction}>
                {/* <Button type="primary" onClick={SubmitCardTransaction}> */}
                Pay Now
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "2",
      label: "Credit Card",
      children: (
        <>
          <Typography.Title level={4} className="card-title">
            Credit Card Payment Information
          </Typography.Title>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <label className="col-form-label-sm" htmlFor="first_name_on_card">
                First Name *
              </label>
              <Input
                size="large"
                type="text"
                id="first_name_on_card"
                name="first_name_on_card"
                value={paymentDetails?.first_name}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, first_name: e.target.value });
                }}
                placeholder="John"
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm" htmlFor="last_name_on_card">
                Last Name *
              </label>
              <Input
                size="large"
                type="text"
                id="last_name_on_card"
                name="last_name_on_card"
                value={paymentDetails?.last_name}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, last_name: e.target.value });
                }}
                placeholder="Smith"
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm" htmlFor="card_number">
                Card Number *
              </label>
              <PatternFormat
                id="card_number"
                className="form-control form-control-lg"
                format="#### #### #### ####"
                mask="-"
                placeholder="---- ---- ---- ----"
                allowLeadingZeros={true}
                value={paymentDetails.viewable_card_number}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, card_number: e.target.value.replaceAll(" ", "").replaceAll("-", ""), viewable_card_number: e.target.value });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm" htmlFor="card_expiry">
                Card Expiration *
              </label>
              <PatternFormat
                id="card_expiry"
                className="form-control form-control-lg"
                format="##/##"
                mask="-"
                placeholder="MM/YY"
                allowLeadingZeros={true}
                value={paymentDetails?.card_expiry_month && paymentDetails?.card_expiry_year ? paymentDetails?.card_expiry_month + paymentDetails?.card_expiry_year.substring(2) : null}
                onChange={(e) => {
                  setPaymentDetails({
                    ...paymentDetails,
                    card_expiry_month: e.target.value.substr(0, Number(e.target.value.indexOf("/"))),
                    card_expiry_year: "20" + e.target.value.substr(e.target.value.indexOf("/") + 1),
                  });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm" htmlFor="card_ccv">
                CCV *
              </label>
              <NumericFormat
                id="card_ccv"
                className="form-control form-control-lg"
                format="###"
                mask="-"
                placeholder="---"
                allowLeadingZeros={true}
                value={paymentDetails?.ccv}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, card_ccv: e.target.value });
                }}
              />
            </Col>
            <Col span={10}>
              <label className="col-form-label-sm" htmlFor="card_zip">
                Zip *
              </label>
              <NumericFormat
                id="card_zip"
                className="form-control form-control-lg"
                format="#####"
                mask="-"
                placeholder="-----"
                allowLeadingZeros={true}
                value={paymentDetails?.card_zip}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, card_zip: e.target.value });
                }}
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm" htmlFor="card_zip">
                Memo
              </label>
              <Input.TextArea
                maxLength={1000}
                showCount
                value={paymentDetails?.memo}
                onChange={(e) => {
                  setPaymentDetails({ ...paymentDetails, memo: e.target.value });
                }}
              />
            </Col>
            <Col span={24} className="text-right mt-2">
              <Button type="primary" loading={paymentProcessing} onClick={SubmitCardTransaction}>
                Pay Now
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "3",
      label: (
        <>
          <Tooltip title="Coming Soon!">ACH</Tooltip>
        </>
      ),
      disabled: true,
      children: "Content of Tab Pane 3",
    },
  ];

  useEffect(() => {
    if (params?.invoice_tag && params.client_tag) GetInvoice();
    if (params?.client_tag && params.company_tag) GetClient();
    if (!params?.invoice_tag && !params.client_tag) GetCompany();
    window.AnimatePaymentSuccess = AnimatePaymentSuccess;
    window.HandleForteSuccess = HandleForteSuccess;
    window.HandleForteFailure = HandleForteFailure;
  }, []);

  useEffect(() => {
    ReadSwipeInput();
  }, [paymentDetails.first_name]);

  return (
    <div className="container" style={{ marginTop: "60px" }}>
      {console.log(apiLoginId)}
      <Animate
        play={animation1Playing}
        sequenceIndex={0}
        duration={2}
        delay={1}
        start={{ transform: "translate(0, 0)" }}
        end={{ transform: "translate(-150%, 0)" }}
        onComplete={() => {
          setAnimation2Playing(true);
        }}
        easeType="cubic-bezier(0.65, 0, 0.35, 1)"
      >
        {!company && !invoice && !client ? <Skeleton style={{ height: "50vh" }} active /> : null}
        {company && !invoice && !client ? (
          <Row gutter={[16, 16]} style={animation2Playing ? { display: "none" } : {}}>
            <Col span={4}></Col>
            <Col span={16}>
              <Card
                title={
                  <>
                    <Row gutter={[16, 16]}>
                      <Col span={24} className="text-center">
                        <img
                          className="card-img-top mt-3"
                          src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company.image_link}
                          alt="Unsplash"
                          style={{ height: "auto", width: "auto", maxWidth: "50%", maxHeight: "55%" }}
                        />
                      </Col>
                      <Col span={24}>
                        <Typography.Title level={3} className="mx-5">
                          <Typography.Title level={4} className="text-muted">
                            Payment to
                          </Typography.Title>
                          {company.name}
                        </Typography.Title>
                      </Col>
                    </Row>
                  </>
                }
              >
                <Row gutter={[16, 16]}>
                  <Col span={16}>
                    <label className="card-title card-subtitle text-muted">Payment</label>
                    {paymentDetails?.editing ? (
                      <Input
                        ref={focusOnEdit}
                        prefix="$"
                        value={paymentDetails.total}
                        onChange={(e) => {
                          setPaymentDetails({ ...paymentDetails, total: e.target.value });
                        }}
                        onBlurCapture={() => {
                          setPaymentDetails({ ...paymentDetails, editing: false });
                        }}
                      />
                    ) : (
                      <Typography.Title
                        level={3}
                        className="clickable"
                        data-tip="Click to Edit Amount"
                        onClick={() => {
                          setPaymentDetails({ ...paymentDetails, editing: true });
                          focusOnEdit?.current?.focus();
                        }}
                      >
                        {props.FormatNumberToCurrency(paymentDetails?.total)}
                      </Typography.Title>
                    )}
                  </Col>
                  <Col
                    span={8}
                    className="clickable"
                    onClick={() => {
                      setPaymentDetails({ ...paymentDetails, editing: true });
                      focusOnEdit?.current?.focus();
                    }}
                  >
                    <p className="text-muted w-100 h-100 top-50 text-center position-relative">Click to edit the amount</p>
                  </Col>
                </Row>
                <hr></hr>
                <Tabs items={payment_tabs} />
              </Card>
              {company && !invoice && client ? (
                <Card>
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <label className="card-title card-subtitle text-muted">Payment</label>
                      {paymentDetails?.editing ? (
                        <Input
                          ref={focusOnEdit}
                          prefix="$"
                          value={paymentDetails.total}
                          onChange={(e) => {
                            setPaymentDetails({ ...paymentDetails, total: e.target.value });
                          }}
                          onBlurCapture={() => {
                            setPaymentDetails({ ...paymentDetails, editing: false });
                          }}
                        />
                      ) : (
                        <Typography.Title
                          level={3}
                          className="clickable"
                          data-tip="Click to Edit Amount"
                          onClick={() => {
                            setPaymentDetails({ ...paymentDetails, editing: true });
                            focusOnEdit?.current?.focus();
                          }}
                        >
                          {props.FormatNumberToCurrency(paymentDetails?.total)}
                        </Typography.Title>
                      )}
                    </Col>
                    <Col
                      span={8}
                      className="clickable"
                      onClick={() => {
                        setPaymentDetails({ ...paymentDetails, editing: true });
                        focusOnEdit?.current?.focus();
                      }}
                    >
                      <p className="text-muted w-100 h-100 top-50 text-center position-relative">Click to edit the amount</p>
                    </Col>
                  </Row>
                  <hr></hr>
                  <Tabs items={payment_tabs} />
                </Card>
              ) : null}
            </Col>
          </Row>
        ) : (
          <Row gutter={[16, 16]} style={animation2Playing ? { display: "none" } : {}}>
            <Col span={8}>
              {!company && !invoice && !client ? <Skeleton active /> : null}
              {company && invoice && client ? (
                <Card
                  title={
                    <div>
                      {company?.image_link && company?.name ? (
                        <img
                          className="card-img-top mt-3"
                          src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company.image_link}
                          alt="Unsplash"
                          style={{ height: "auto", width: "auto", maxWidth: "50%" }}
                        />
                      ) : null}
                      <Typography.Title level={3} className="card-title mb-2">
                        {company?.name}
                      </Typography.Title>
                    </div>
                  }
                >
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <p>Invoice</p>
                    </Col>
                    <Col span={12} className="text-right">
                      <p>{"#" + invoice.name}</p>
                    </Col>
                    <hr />
                    <Col span={12}>
                      <p>Due Date</p>
                    </Col>
                    <Col span={12} className="text-right">
                      <p>{props.MakeDateTimeReadable(invoice.due_at)}</p>
                    </Col>
                    <hr />
                    <Col span={12}>
                      <p>Invoice Total</p>
                    </Col>
                    <Col span={12} className="text-right">
                      <p>{props.FormatNumberToCurrency(invoice.total)}</p>
                    </Col>
                  </Row>
                </Card>
              ) : null}
              {company && !invoice && client ? (
                <Card
                  title={
                    <div>
                      {company?.image_link && company?.name ? (
                        <img
                          className="card-img-top mt-3"
                          src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company.image_link}
                          alt="Unsplash"
                          style={{ height: "auto", width: "auto", maxWidth: "50%" }}
                        />
                      ) : null}
                      <Typography.Title level={3} className="card-title mb-2">
                        {company?.name}
                      </Typography.Title>
                    </div>
                  }
                >
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <p>Client</p>
                    </Col>
                    <Col span={12} className="text-right">
                      <p>{client.name}</p>
                    </Col>
                    <Col span={12}>
                      <p> Date</p>
                    </Col>
                    <Col span={12} className="text-right">
                      <p>{props.MakeDateTimeReadable(dayjs())}</p>
                    </Col>
                  </Row>
                </Card>
              ) : null}
            </Col>
            <Col span={16}>
              {invoice && client && company ? (
                <Card
                  title={
                    <Typography.Title level={3} className="mt-2">
                      Invoice {"#" + invoice?.name}
                    </Typography.Title>
                  }
                >
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <label className="card-title card-subtitle text-muted">Payment</label>
                      {paymentDetails?.editing ? (
                        <Input
                          ref={focusOnEdit}
                          prefix="$"
                          value={paymentDetails.total}
                          onChange={(e) => {
                            setPaymentDetails({ ...paymentDetails, total: e.target.value });
                          }}
                          onBlurCapture={() => {
                            setPaymentDetails({ ...paymentDetails, editing: false });
                          }}
                        />
                      ) : (
                        <Typography.Title
                          level={3}
                          className="clickable"
                          data-tip="Click to Edit Amount"
                          onClick={() => {
                            setPaymentDetails({ ...paymentDetails, editing: true });
                            focusOnEdit?.current?.focus();
                          }}
                        >
                          {props.FormatNumberToCurrency(paymentDetails?.total)}
                        </Typography.Title>
                      )}
                    </Col>
                    <Col
                      span={8}
                      className="clickable"
                      onClick={() => {
                        setPaymentDetails({ ...paymentDetails, editing: true });
                        focusOnEdit?.current?.focus();
                      }}
                    >
                      <p className="text-muted w-100 h-100 top-50 text-center position-relative">Click to edit the amount</p>
                    </Col>
                  </Row>
                  <hr></hr>
                  <Tabs items={payment_tabs} />
                </Card>
              ) : null}
              {company && !invoice && client ? (
                <Card>
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <label className="card-title card-subtitle text-muted">Payment</label>
                      {paymentDetails?.editing ? (
                        <Input
                          ref={focusOnEdit}
                          prefix="$"
                          value={paymentDetails.total}
                          onChange={(e) => {
                            setPaymentDetails({ ...paymentDetails, total: e.target.value });
                          }}
                          onBlurCapture={() => {
                            setPaymentDetails({ ...paymentDetails, editing: false });
                          }}
                        />
                      ) : (
                        <Typography.Title
                          level={3}
                          className="clickable"
                          data-tip="Click to Edit Amount"
                          onClick={() => {
                            setPaymentDetails({ ...paymentDetails, editing: true });
                            focusOnEdit?.current?.focus();
                          }}
                        >
                          {props.FormatNumberToCurrency(paymentDetails?.total)}
                        </Typography.Title>
                      )}
                    </Col>
                    <Col
                      span={8}
                      className="clickable"
                      onClick={() => {
                        setPaymentDetails({ ...paymentDetails, editing: true });
                        focusOnEdit?.current?.focus();
                      }}
                    >
                      <p className="text-muted w-100 h-100 top-50 text-center position-relative">Click to edit the amount</p>
                    </Col>
                  </Row>
                  <hr></hr>
                  <Tabs items={payment_tabs} />
                </Card>
              ) : null}
            </Col>
          </Row>
        )}
      </Animate>
      <Animate play={animation2Playing} sequenceIndex={1} duration={1} start={{ opacity: 0 }} end={{ opacity: 1 }}>
        <Row gutter={[16, 16]}>
          <Col span={6}></Col>
          <Col span={12}>
            <Row gutter={[16, 16]} className="mx-auto" id="printer-selection" ref={printableRef}>
              <Col span={24}>
                <Card
                  title={
                    <div className="text-center">
                      {company?.image_link ? (
                        <img
                          className="card-img-top mt-3"
                          src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company?.image_link}
                          alt="Company Logo"
                          style={{ height: "auto", width: "auto", maxWidth: "50%" }}
                        />
                      ) : null}
                      <Typography.Title level={3}>{company?.name}</Typography.Title>
                    </div>
                  }
                >
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <h3>Receipt of Payment</h3>
                    </Col>

                    {invoice && company && client ? (
                      <>
                        <Col span={12}>
                          <p>Invoice: </p>
                        </Col>

                        <Col span={12} className=" text-right">
                          <p>{"#" + invoice?.name}</p>
                        </Col>
                      </>
                    ) : null}
                    <hr />
                    <Col span={12}>
                      <p>Payee: </p>
                    </Col>
                    <Col span={12} className=" text-right">
                      <p>{paymentDetails.first_name + " " + paymentDetails.last_name}</p>
                    </Col>
                    <hr />
                    <Col span={12}>
                      <p>Date: </p>
                    </Col>
                    <Col span={12} className=" text-right">
                      <p>{props.MakeDateTimeReadable(dayjs())}</p>
                    </Col>
                    <hr />
                    {invoice && company && client ? (
                      <>
                        <Col span={12}>
                          <p>Invoice Total: </p>
                        </Col>
                        <Col span={12} className=" text-right">
                          <p>{props.FormatNumberToCurrency(paymentDetails?.total)}</p>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col span={12}>
                          <p>Amount Paid: </p>
                        </Col>
                        <Col span={12} className=" text-right">
                          <p>{props.FormatNumberToCurrency(paymentDetails?.total)}</p>
                        </Col>
                      </>
                    )}

                    {paymentDetails?.memo?.length > 0 ? (
                      <>
                        <hr />
                        <Col span={12}>
                          <p>Memo: </p>
                        </Col>
                        <Col span={12} className="text-right">
                          <p>{paymentDetails.memo}</p>
                        </Col>
                      </>
                    ) : null}
                  </Row>

                  <Row gutter={[16, 16]} className="alert-dark text-center rounded">
                    <Col span={24} style={{ whiteSpace: "nowrap" }}>
                      <small style={{ color: "white" }}>Powered by FirmTamer</small>
                      <img
                        className="card-img"
                        src="https://firmtamer-public-bucket.s3.amazonaws.com/firmtamer-mascot-no-bg.png"
                        alt="FirmTamer Logo"
                        style={{ maxWidth: "50px", backgroundColor: "transparent" }}
                      />
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <ReactToPrint
              bodyClass="row"
              trigger={() => {
                return (
                  <Button type="primary">
                    <FontAwesomeIcon icon={faPrint} className="mr-2" />
                    Print
                  </Button>
                );
              }}
              content={() => printableRef.current}
            />
          </Col>
        </Row>
      </Animate>
    </div>
  );
}

export default PortalPayment;
